export default function (state) {
    let date = new Date();
    state.dateType = 1;
    state.dates = [
        '' + (date.getDate() > 9 ? '' : '0') + date.getDate() + '.' + (date.getMonth() > 8 ? '' : '0') + (date.getMonth() + 1) + '.' + date.getFullYear(),
        '' + (date.getDate() > 9 ? '' : '0') + date.getDate() + '.' + (date.getMonth() > 8 ? '' : '0') + (date.getMonth() + 1) + '.' + date.getFullYear()
    ];
    state.CurrencyId = [];
    state.DepartmentList = [];
    state.ManagerList = [];
    state.CashList = [];
    state.PaymentAccountList = [];
    state.Direction = 0;
    state.ContragentID = 0;
    state.ContragentType = 0;
    state.ContragentSearchTypeId = 0;
    state.AgreementCode = '';
    state.RequestNumber = '';
    state.PaymentReason = '';
    state.DocumentNumber = '';
    state.AccountNumber = '';
    state.PaymentOperationID = '';
    state.CategoryId = '';
    state.PaymentTypeId = '';
    state.StatementName = '';
    state.MinAmount = 0;
    state.MaxAmount = 0;
    state.DateStatement = '';
    state.PaySystemTransactionId = '';
    state.PaymentMethodId = null;
    state.KindOfPayId = '';
    state.RateArticleId = '';
    state.NoDetailedOnly = false;
    state.addCashCheck = false;
    state.OnlineCashId = 0;
    state.BillProvideTypeId = 1;
}